import { useContext } from 'react';
import context, { Context } from 'components/UserProvider/context';

const useUserRoles = () => useContext<Context>(context);

export default useUserRoles;
